import styles from './Catalog.module.scss';

export default function Catalog() {
  return (
    <div className={styles.catalogContainer}>
      <h2>Product Catalog</h2>
      <div className={styles.catalogGrid}>
        <div className={styles.catalogItem}>
          <h3>Product 1</h3>
          <p>Description of product 1</p>
          <span className={styles.price}>$99.99</span>
        </div>
        <div className={styles.catalogItem}>
          <h3>Product 2</h3>
          <p>Description of product 2</p>
          <span className={styles.price}>$149.99</span>
        </div>
        <div className={styles.catalogItem}>
          <h3>Product 3</h3>
          <p>Description of product 3</p>
          <span className={styles.price}>$199.99</span>
        </div>
      </div>
    </div>
  );
} 